import { Check, CheckCheck } from 'lucide-react';

interface MessageStatusProps {
  isRead: boolean;
}

export const MessageStatus = ({ isRead }: MessageStatusProps) => {
  if (isRead) {
    return <CheckCheck className="h-3.5 w-3.5 text-primary inline-block ml-1" />;
  }
  return <Check className="h-3.5 w-3.5 text-muted-foreground inline-block ml-1" />;
};
